<template>
  <div>
    <span class="relative z-0 inline-flex shadow-sm rounded-md">
      <button
        type="button"
        @click="onReaction"
        class="relative inline-flex items-center px-4 py-2 rounded-l-md border border-green
        text-sm leading-5 font-medium text-gray-700 hover:text-gray-500 focus:z-10 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150"
      >
        <svg
          class="h-5 w-5 text-gray-600"
          v-bind:class="{
            'text-green': !hasLiked,
            'text-red-600 fill-current': hasLiked
          }"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
          ></path>
        </svg>
      </button>
      <a
        class="-ml-px font-bebas relative inline-flex items-center px-3 py-2 rounded-r-md border border-green text-sm leading-5 font-medium text-gray-700 hover:text-gray-500 focus:z-10 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150"
      >
        {{ likeCount }}
      </a>
    </span>
  </div>
</template>

<script>
import { auth, projectsCollection } from "../utils/firebase";

export default {
  name: "ReactionBar",
  props: {
    documentId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      reactions: [],
      hasLiked: false,
      unsubscribeReactions: null,
      unsubscribeUserReaction: null,
      reactionsCollection: null
    };
  },
  created() {
    this.reactionsCollection = projectsCollection
      .doc(this.documentId)
      .collection("reactions");
    this.fetchReactions();
  },
  methods: {
    fetchReactions() {
      this.unsubscribeReactions = this.reactionsCollection
        .where("topic", "==", this.documentId)
        .onSnapshot(querySnapshot => {
          this.reactions = [];
          querySnapshot.forEach(doc => {
            this.reactions.push(doc.data());
          });
        });

      if (auth.currentUser) {
        this.unsubscribeUserReaction = this.reactionsCollection
          .where("topic", "==", this.documentId)
          .where("user", "==", auth.currentUser.uid)
          .onSnapshot(querySnapshot => {
            this.hasLiked = !querySnapshot.empty;
          });
      }
    },
    onReaction() {
      if (this.hasLiked) {
        return;
      }
      this.reactionsCollection
        .add({
          topic: this.documentId,
          reaction: 0,
          user: auth.currentUser.uid
        })
        .then(docRef => console.log("Document written with ID: ", docRef.id))
        .catch(error => console.error("Error adding a document", error));
    }
  },
  beforeDestroy() {
    if (this.unsubscribeReactions) {
      this.unsubscribeReactions();
    }
    if (this.unsubscribeUserReaction) {
      this.unsubscribeUserReaction();
    }
  },
  computed: {
    likeCount() {
      return this.reactions.length;
    }
  }
};
</script>

<style scoped></style>
